/**
 * Stable per-browser device identity for the MEDIS `/NewSession` handshake.
 * Mirrors the mobile app's device id + user agent, persisted so the same
 * browser reuses one id across sessions.
 */

const DEVICE_ID_KEY = 'gral.device.id';

function generateId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers.
  return 'web-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = generateId();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

export function getUserAgent(): string {
  return typeof navigator !== 'undefined' ? navigator.userAgent : 'gral-web-client';
}
